import { Props_SnippetContentGrid } from './ContentGrid.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetContentGrid = (props: Props_SnippetContentGrid) => {
    const { heading, content, repeatable_entry } = props
    
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content-grid__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-content-grid">
            <div className="snippet-content-grid__container">
                <h2 className={`snippet-content-grid__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                { content.content?.value && <div className="snippet-content-grid__content">{ Legacy_CompileMarkdown(content.content.value) }</div> }
                <div className="snippet-content-grid__container-grid">
                { repeatable_entry.map((entry, index: number) => (
                    <div key={index} className={`snippet-content-grid__entry`}>
                        { entry.image?.value && (
                            <figure className="snippet-content-grid__entry-image-container">
                                <img
                                    className="snippet-content-grid__entry-image"
                                    loading="lazy"
                                    height={190}
                                    width={350}
                                    src={entry.image.value}
                                    alt={entry.alt?.value ? entry.alt.value : ''}
                                />
                            </figure>
                        )}
                        <div className="snippet-content-grid__entry-content-container">
                            { entry.heading?.value && <h3 className="snippet-content-grid__entry-title">{ entry.heading.value }</h3>}
                            { entry.content?.value && <div className="snippet-content-grid__entry-content">{ Legacy_CompileMarkdown(entry.content.value) }</div> }
                            { entry.linkText?.value && entry.url?.value && entry.openInNewTab?.value && (
                                <a
                                    href={entry.url.value}
                                    className="snippet-content-grid__entry-link"
                                    target={entry.openInNewTab.value === 'true' ? '_blank' : '_self'}
                                >
                                    { entry.linkText.value }
                                </a>
                            )}
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </section>
    )}

export default SnippetContentGrid
